import React, { useCallback, useState } from "react";
import Config from "../model/config";
import User from '../model/User'

interface AuthContextType {
    setIsLoggedContext: (value: boolean) => void;
    setUserInstance: (value: any) => void;
    setWidthContext: (value: number) => void;
    setConfigContext: (value: Config) => void;
    isLogged: boolean
    user: User;
    width: number;
    isMobileWidth: boolean;
    configs?: Config;
}

let AuthContext = React.createContext<AuthContextType>(null!);

export function useCustomContext() {
    return React.useContext(AuthContext);
}

export default function AuthProvider({ children }: { children: React.ReactNode }) {
    const [isLogged, setIsLogged] = useState(false);
    const [user, setUser] = useState<User>(new User('', '', '', false, '', false))
    const [width, setWindowWidth] = useState(0);
    const [configs, setConfigs] = useState<Config>();

    const isMobileWidth = 600 > width

    const setIsLoggedContext = useCallback((value: boolean): void => {
        setIsLogged(value);
    }, []);

    const setUserInstance = useCallback((value: User): void => {
        setUser(value);
    }, []);

    const setWidthContext = (value: number): void => {
        setWindowWidth(value)
    }

    const setConfigContext = useCallback((value: Config): void => {
        setConfigs(value);
    }, []);

    let value = { isLogged, setIsLoggedContext, setUserInstance, user, width, setWidthContext, isMobileWidth, configs, setConfigContext };

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}


